module.exports = __webpack_public_path__ + "img/dia.cover.f8bf6a51.png";